import { createTheme } from "@mui/material/styles";

const profitColor = "#18b009";
const lossColor = "#fa2104";
const neutralColor = "#d5c505";

const baseTheme = createTheme({
  breakpoints: {
    values: { xs: 0, sm: 480, md: 768, lg: 1024, xl: 1440 },
  },
  palette: {
    sectionHeading: "#0550d5",
    profitColor,
    lossColor,
    neutralColor,
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    color: "#04a19b",
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: "bold",
          backgroundColor: "rgba(0,0,0,0.06)",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .profit-cell": { color: profitColor, fontWeight: "bold" },
          "& .loss-cell": { color: lossColor, fontWeight: "bold" },
          "& .neutral-cell": { color: neutralColor },
        },
        columnHeaders: {
          "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold", color: "#3104a1" },
        },
      },
    },
  },
});

export default baseTheme;
export { profitColor, lossColor, neutralColor };
